import { Directive, ElementRef, Input, OnInit, OnChanges, Renderer2, HostBinding, Inject, OnDestroy } from '@angular/core';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';
import { PubNubNotifier } from 'angular-engine/engine/service/notification/pubnub.notification.service';
import { InteractiveComponentService } from 'angular-engine/engine/service/ui/components/interactive-component.ott.service';
import { DataSourceComponent } from '../shared-component/data-source.component';

@Directive({
    selector: '[trackPushNotifications]'
})
export class TrackPushNotifications implements OnInit, OnDestroy {
    @Input("trackPushNotifications") data: Array<any>;

    protected notifcation: any;
    protected targetIndex: number;
    protected subscriptions: Array<any> = [];

    constructor(protected el: ElementRef,
        @Inject(APP_SETTINGS) protected settings: any,
        protected pubnubEngine: PubNubNotifier,
        protected eventInteraction: EventInteraction,
        public component: DataSourceComponent,
        protected uiService: InteractiveComponentService,
    ) { }

    ngOnInit() {
        if (this.settings.PUBNUB_ENABLED && this.settings.NOTIFICATION_MESSAGES) {
            if (this.component && this.component.data && this.component.data.length > 0) {
                const target = this.component.data.find(i => i.meta && i.meta.obj_type == "Notification");
                if (target) {
                    this.notifcation = { ...target }
                    
                    // applies current message state
                    target.meta.item = this.pubnubEngine.getLastNotification()
                    this.uiService.updateNotificationDataSourceFromMessage(target.meta.item, this.component, this.notifcation)

                    // subscribes to pubnub notification changes
                    this.subscriptions.push(this.eventInteraction.subscribe(msg => {
                        if (msg.key == "noticationMessageChange") {
                            this.uiService.updateNotificationDataSourceFromMessage(msg.message, this.component, this.notifcation);
                        }
                    }));
                }
            }
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-directives/track-pn-notifications.directive.ts